import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { buildLogoutRequest, consumeLoginRequest } from './auth/authConfig';
import { AccessGate } from './components/AccessGate';
import { LandingView } from './components/LandingView';
import { DevHealthPanel } from './components/DevHealthPanel';

/**
 * App root. Deny-by-default: the unauthenticated `LandingView` is shown until the
 * user signs in via Entra ID; the authenticated path delegates to `AccessGate`,
 * which owns the access-state machine and chooses the shell (routed task-based
 * shell behind `VITE_UCP_ROUTER_SHELL`, else the legacy `AppShell` — PRO-0250).
 *
 * App no longer wraps everything in a single `<main>`: each branch owns exactly
 * one `<main>` landmark (LandingView / the AccessGate frame / the routed shell),
 * so there is never a duplicate or nested `main` (NF-10). `DevHealthPanel` is
 * dev-only.
 */
export function App() {
  const { instance } = useMsal();

  return (
    <>
      <UnauthenticatedTemplate>
        <LandingView onSignIn={() => void instance.loginRedirect(consumeLoginRequest())} />
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <AccessGate
          onSignOut={() => void instance.logoutRedirect(buildLogoutRequest(instance))}
          onReauthenticate={() => void instance.loginRedirect(consumeLoginRequest())}
        />
      </AuthenticatedTemplate>

      <DevHealthPanel />
    </>
  );
}
